export default __webpack_public_path__ + "static/media/loading.9cba8d73.gif";